import { render, staticRenderFns } from "./Comportamiento.vue?vue&type=template&id=c95fd988&scoped=true&"
import script from "./Comportamiento.vue?vue&type=script&lang=js&"
export * from "./Comportamiento.vue?vue&type=script&lang=js&"
import style0 from "./Comportamiento.vue?vue&type=style&index=0&id=c95fd988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95fd988",
  null
  
)

export default component.exports